import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, resolveMediaUrl } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function Messages() {
  const { user } = useAuth();
  const { t } = useLanguage();
  const [chats, setChats] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchChats = async () => {
    if (!user?.id) return;
    setLoading(true);
    try {
      const response = await api.get('/api/chatList', { params: { userId: user.id } });
      setChats(response.data || []);
    } catch (err) {
      setChats([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChats();
  }, [user?.id]);

  return (
    <div className="list">
      <div className="card">
        <h2 className="section-title">{t('messages.title')}</h2>
        <p className="section-subtitle">{t('messages.subtitle')}</p>
      </div>
      {loading ? (
        <div className="card">{t('messages.loading')}</div>
      ) : (
        chats.map((chat) => {
          const avatar = resolveMediaUrl(chat.userImage);
          return (
            <Link key={chat.contactId} to={`/mesajlar/${chat.contactId}`} className="card">
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <div className="brand-mark" style={{ background: 'linear-gradient(135deg,#f97316,#facc15)' }}>
                  {chat.nickName?.slice(0, 1)?.toUpperCase() || 'A'}
                </div>
                {avatar ? (
                  <img src={avatar} alt={chat.nickName} style={{ width: 52, height: 52, borderRadius: 18 }} />
                ) : null}
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700 }}>{chat.nickName}</div>
                  <div className="muted" style={{ fontSize: 13 }}>
                    {chat.lastMessage || t('messages.fileSent')}
                  </div>
                </div>
                <div className="muted" style={{ fontSize: 12 }}>
                  {chat.timestamp ? new Date(chat.timestamp).toLocaleDateString() : ''}
                </div>
              </div>
            </Link>
          );
        })
      )}
    </div>
  );
}
